import { PENDING_SUBSCRIPTIONS, SUBSCRIPTIONS } from '~/constants/sockets';
import { type Subscription } from '~/types/sockets';

// https://linear.app/air/issue/ENG-128/update-getiterablesubscriptions-to-not-use-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EMPTY_LIST: Subscription<any>[] = [];

// https://linear.app/air/issue/ENG-128/update-getiterablesubscriptions-to-not-use-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getIterableSubscriptions = (isPending?: boolean): Subscription<any>[] => {
  const subscriptionKeys = Object.keys(isPending ? PENDING_SUBSCRIPTIONS : SUBSCRIPTIONS);

  if (!subscriptionKeys.length) {
    return EMPTY_LIST;
  }

  return subscriptionKeys.map((key) => (isPending ? PENDING_SUBSCRIPTIONS[key] : SUBSCRIPTIONS[key]));
};
